import { render, staticRenderFns } from "./GoogleSlideTutorial.vue?vue&type=template&id=3fa7c979&scoped=true"
import script from "./GoogleSlideTutorial.vue?vue&type=script&lang=js"
export * from "./GoogleSlideTutorial.vue?vue&type=script&lang=js"
import style0 from "./GoogleSlideTutorial.vue?vue&type=style&index=0&id=3fa7c979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7c979",
  null
  
)

export default component.exports